import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, SubmitInput, Error, Success } from './styles';
import { useAdminFunction } from '../../hooks/useAdminFunction';
import { AWSStatusIndicator } from '../../components';

const ScheduleNotification: React.FC = () => {
  const navigate = useNavigate();
  const { callFunction, isAuthenticated } = useAdminFunction();
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleYesClick = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!isAuthenticated) {
      navigate('/admin/login');
      return;
    }

    const target = e.target as typeof e.target & {
      text: { value: string };
      date: { value: string };
      hour: { value: number };
    };
    
    const text = target.text.value;
    const date = target.date.value;
    const hour = target.hour.value;

    if (!text || !date || !hour || Number(hour) <= 0) {
      alert('Invalid input for schedule notifications');
      return;
    }

    setIsLoading(true);

    try {
      await callFunction('scheduleMassNotification', {
        text,
        date,
        hour: Number(hour)
      });
      setSuccess('Successfully scheduled a mass notification');
    } catch (error: any) {
      console.error('Failed to schedule notification:', error);
      setError(error?.message || error?.error || 'Failed to schedule notification');
    } finally {
      setIsLoading(false);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleNoClick = () => {};

  const handleAlert = (e: React.SyntheticEvent) => {
    const confirmed = window.confirm('Are you sure you want to create a MASS notification?');
    if (confirmed) {
      handleYesClick(e);
    } else {
      handleNoClick();
    }
  };
  return (
    <>
      <AWSStatusIndicator />
      <Form onSubmit={handleAlert}>
      <Input placeholder="Text" name="text" />
      <Input placeholder="Date" type="date" name="date" />
      <Input placeholder="Hour" type="number" min="0" max="23" name="hour" />
      <SubmitInput type="submit" value={isLoading ? "Scheduling..." : "Schedule"} disabled={isLoading || !isAuthenticated} />
        {error.length > 0 && <Error>{error}</Error>}
        {success.length > 0 && <Success>{success}</Success>}
      </Form>
    </>
  );
};

export { ScheduleNotification };
